export default __webpack_public_path__ + "static/media/EmptyTable.24667d96.svg";